// extracted by mini-css-extract-plugin
export default {"verify-email-banner":"VerifyEmailBanner_verify-email-banner__CLPma"};